import {
  HandleNextYearClick,
  HandlePrevYearClick,
  YearPicker,
} from '@/domain/mitarbeiter/features/feiertagskonto/components/dateNavigation/shared';

export function DateNavigatorMobile() {
  return (
    <div className="flex flex-row justify-between items-center bg-backgrounds-primary w-full px-4 py-2 text-brand-blue-100">
      <HandlePrevYearClick />
      <YearPicker />
      <HandleNextYearClick />
    </div>
  );
}
